import type { Member, PersonalField } from '../types'

export type PersonalStatus = 'popolni' | 'delno'

export function missingFields(m: Member, polja: PersonalField[]): PersonalField[] {
  return polja.filter((p) => {
    const v = m[p]
    return v === undefined || v === null || String(v).trim() === ''
  })
}

export function personalStatus(m: Member, polja: PersonalField[]): PersonalStatus {
  return missingFields(m, polja).length === 0 ? 'popolni' : 'delno'
}

export function statusLabelShort(status: PersonalStatus): string {
  return status === 'popolni' ? 'Podatki popolni' : 'Potrebna dopolnitev'
}
